// extracted by mini-css-extract-plugin
export var explainable = "_go-a";
export var printerCard = "_go-1";
export var printerCardConfigured = "_go-2";
export var printerCardError = "_go-3";
export var printerCardsContainer = "_go-0";
export var printerIcon = "_go-8";
export var printerIconConfigured = "_go-5";
export var printerIconContainer = "_go-4";
export var printerIconError = "_go-6";
export var printerIconUnconfigured = "_go-7";
export var workstationsTableCard = "_go-9";